import React, { useEffect, useRef } from 'react'
import cn from 'classnames'
import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import KeyboardNavigator from 'components/KeyboardNavigator'
import { propFunc } from 'util/functions'
import { styles } from './styles'

const Item = ({
  itemKey,
  children,
  tooltip,
  onSelect,
  selectedKey,
  visible,
  className,
}) => {
  const itemRef = useRef()
  useEffect(
    () => {
      // Scroll the selected element into view
      if (selectedKey === itemKey && visible && itemRef?.current) {
        itemRef.current.scrollIntoView({ block: 'center', inline: 'nearest' })
      }
    },
    [selectedKey, itemKey, visible]
  )
  return (
    <KeyboardNavigator.Item
      key={itemKey}
      onSelect={propFunc(onSelect, itemKey)}
      css={styles.item}
      active={itemKey === selectedKey}
      className={cn(itemKey === selectedKey && 'selected', className)}
      role="menuitem"
    >
      <div
        className={cn('grui truncate', tooltip && 'flex items-center')}
        ref={itemRef}
      >
        {children}
        {tooltip && (
          <Tooltip
            title={tooltip}
            strategy="fixed"
            portal="#overlays"
            css={styles.tooltip}
          >
            <div css={styles.tooltipIcon}>i</div>
          </Tooltip>
        )}
      </div>
    </KeyboardNavigator.Item>
  )
}

export default Item
